import {
  LegalDocumentType,
  LocationInput,
  MutationUpdateDoorArgs,
  Provider,
  Role
} from 'graphql/generated/graphqlTypes';
import {
  ACCEPT_LEGAL_DOCUMENTS,
  ADD_LOCATION,
  ADD_REST_API_KEY,
  ADD_VISITOR_GROUP_WITH_RETAIL,
  ASSIGN_ACCESS_GRANTS_TO_DOORS,
  ASSIGN_TO_ACCESS_GRANTS,
  CHOOSE_PROVIDER,
  DELETE_DOOR_BY_ID,
  DELETE_LOCATION,
  DELETE_REST_API_KEY,
  GO_BACK_ONE_ONBOARDING_STEP,
  RESEND_VERIFICATION_CODE,
  SET_INSTALLER,
  SET_IS_ADMIN_FOR_GROUP,
  SET_MFA_PREFERENCE,
  SET_VISITOR_BY_ID,
  UNASSIGN_ACCESS_GRANTS_FROM_DOORS,
  UNASSIGN_TO_ACCESS_GRANTS,
  UNSET_INSTALLER_BY_ID,
  UPDATE_ACCESS_GRANT_WITH_IS_OFFICE_MODE_ENABLED,
  UPDATE_DOOR_WITH_LOCATIONS,
  UPDATE_DOOR_WITH_OFFICE_MODE,
  UPDATE_LOCATION,
  UPDATE_REST_API_KEY,
  UPDATE_VISITOR_GROUP_WITH_RETAIL,
  VERIFY_ACCOUNT
} from 'graphql/mutations';
import {
  ADD_VISITOR_GROUP_V2,
  ADD_VISITOR_WITH_ROLE,
  BULK_ADD_VISITORS_TO_VISITOR_GROUPS,
  BULK_ASSIGN_VISITOR_ROLES,
  BULK_DELETE_VISITORS,
  DELETE_VISITOR_BY_ID,
  DELETE_VISITOR_GROUP_BY_ID,
  SET_VISITOR_BY_ID_WITH_ROLE,
  UNREGISTER_MOBILE_DEVICE_BY_ID,
  UPDATE_ACCESS_GRANT,
  UPDATE_VISITOR_GROUP_DETAILS_V2,
  UPDATE_VISITOR_GROUP_V2
} from 'graphql/v2/mutations';
import { mockedAcceptLegalDocumentsDataForMutation1 } from 'mocks/graphqlApollo/mutation/acceptLegalDocuments';
import { mockedAddRestAPIKeyDataForMutation } from 'mocks/graphqlApollo/mutation/addRestAPIKey';
import { mockedBulkAddVisitorsToVisitorGroupsData } from 'mocks/graphqlApollo/mutation/bulkAddVisitorsToVisitorGroups';
import { mockedBulkAssignVisitorRolesData } from 'mocks/graphqlApollo/mutation/bulkAssignVisitorRoles';
import { mockedBulkDeleteVisitorsData } from 'mocks/graphqlApollo/mutation/bulkDeleteVisitors';
import {
  mockedChooseCognitoPrividerDataForQuery,
  mockedChooseEntraPrividerDataForQuery
} from 'mocks/graphqlApollo/mutation/chooseProvider';
import { mockedDeleteRestAPIKeyDataForMutation } from 'mocks/graphqlApollo/mutation/deleteRestAPIKey';
import { mockedSetMfaPreferenceDataForQuery } from 'mocks/graphqlApollo/mutation/setMfaPreference';
import { mockedUpdateRestAPIKeyDataForMutation } from 'mocks/graphqlApollo/mutation/updateRestAPIKey';
import {
  mockedUpdateVisitorGroupDetailsClearedMaxNumberOfMembersDataForMutation,
  mockedUpdateVisitorGroupDetailsDataForMutation
} from 'mocks/graphqlApollo/mutation/updateVisitorGroupDetails';
import { mockedVerifyCognitoUserDataForQuery } from 'mocks/graphqlApollo/mutation/verifyUserCode';
import { mockedGoBackOneOnboardingStepDataForQuery } from 'mocks/graphqlApollo/query/goBackOneOnboardingStep';
import { VisitorGroupType } from 'utils/VisitorGroup/VisitorGroup';
import { mockedAddLocationWithDoorsDataForMutation } from '../graphqlApollo/mutation/addLocationWithDoors';
import { mockedAddVisitorGroupDataForMutation } from '../graphqlApollo/mutation/addVisitorGroupCoContractor';
import {
  mockedAddVisitorWithRoleDataForMutation1,
  mockedAddVisitorWithRoleDataForMutation2
} from '../graphqlApollo/mutation/addVisitorWithRole';
import { mockedAssignAccessGrantsToDoorsDataForMutation } from '../graphqlApollo/mutation/assignAccessGrantsToDoors';
import {
  mockedAssignToAccessGrantsDataForMutation,
  mockedAssignToAccessGrantsDataForMutation1,
  mockedAssignToAccessGrantsDataForMutation2
} from '../graphqlApollo/mutation/assignToAccessGrants';
import {
  mockedDeleteDoorByIdDataForMutation,
  mockedDeleteDoorByIdDataForMutation1
} from '../graphqlApollo/mutation/deleteDoorById';
import { mockedDeleteLocationDataForMutation } from '../graphqlApollo/mutation/deleteLocation';
import { mockedDeleteVisitorByIdDataForMutation } from '../graphqlApollo/mutation/deleteVisitorById';
import { mockedDeleteVisitorGroupDataForMutation } from '../graphqlApollo/mutation/deleteVisitorGroup';
import { mockedSetInstallerDataForMutation } from '../graphqlApollo/mutation/setInstaller';
import { mockedSetIsAdminForGroupDataForMutation } from '../graphqlApollo/mutation/setIsAdminForGroup';
import {
  mockedSetVisitorDataForMutation,
  mockedUpdateInstallerDataForMutation
} from '../graphqlApollo/mutation/setVisitorById';
import { mockedSetVisitorWithRoleDataForMutation } from '../graphqlApollo/mutation/setVisitorByIdWithRole';
import { mockedUnassignAccessGrantsToDoorsDataForMutation } from '../graphqlApollo/mutation/unassignAccessGrantsToDoors';
import {
  mockedUnassignToAccessGrantsDataForMutation,
  mockedUnassignToAccessGrantsDataForMutation1,
  mockedUnassignToAccessGrantsDataForMutation2
} from '../graphqlApollo/mutation/unassignToAccessGrants';
import {
  mockedUnregisterMobileDeviceDataForMutation,
  mockedUnregisterMobileDeviceDataForMutation1
} from '../graphqlApollo/mutation/unregisterMobileDevice';
import { mockedUnsetInstallerDataDataForMutation } from '../graphqlApollo/mutation/unsetInstallerById';
import {
  mockedUpdateAccessGrantForMutation1,
  mockedUpdateAccessGrantForMutation2
} from '../graphqlApollo/mutation/updateAccessGrant';
import { mockedUpdateAccessGrantWithIsOfficeModeForMutation1 } from '../graphqlApollo/mutation/updateAccessGrantWithIsOfficeModeEnabled';
import { mockedUpdateDoorWithOfficeModeDataForMutation } from '../graphqlApollo/mutation/updateDoor';
import { mockedUpdateDoorWithLocationsDataForMutation } from '../graphqlApollo/mutation/updateDoorWithLocations';
import { mockedUpdateLocationWithDoorsDataForMutation } from '../graphqlApollo/mutation/updateLocationWithDoors';
import { mockedUpdateVisitorGroupDataForMutation } from '../graphqlApollo/mutation/updateVisitorGroup';

export const mutations = [
  {
    request: {
      query: BULK_ADD_VISITORS_TO_VISITOR_GROUPS,
      variables: {
        input: {
          visitorIds: ['mockedVisitorIdExternalUser1'],
          memberships: [{ visitorGroupId: 'mockedVisitorGroupIdExternalUsers1', role: 'NONE' }]
        }
      }
    },
    newData: () => ({
      data: mockedBulkAddVisitorsToVisitorGroupsData()
    })
  },
  {
    request: {
      query: BULK_ASSIGN_VISITOR_ROLES,
      variables: {
        input: {
          visitorIds: ['mockedVisitorIdExternalUser1'],
          roles: ['ADMIN']
        }
      }
    },
    newData: () => ({
      data: mockedBulkAssignVisitorRolesData()
    })
  },
  {
    request: {
      query: BULK_DELETE_VISITORS,
      variables: {
        input: {
          visitorIds: ['mockedVisitorIdExternalUser1']
        }
      }
    },
    newData: () => ({
      data: mockedBulkDeleteVisitorsData()
    })
  },
  {
    request: {
      query: UNREGISTER_MOBILE_DEVICE_BY_ID,
      variables: { visitorId: 'mockedAutomatedTestsUIAdminVisitorId', mobileDeviceId: 'mockedMobileDevice' }
    },
    result: { data: mockedUnregisterMobileDeviceDataForMutation },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: UNREGISTER_MOBILE_DEVICE_BY_ID,
      variables: { visitorId: 'mockedVisitorIdExternalUser2', mobileDeviceId: 'mockedMobileDevice' }
    },
    result: { data: mockedUnregisterMobileDeviceDataForMutation1 },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: UPDATE_DOOR_WITH_OFFICE_MODE,
      variables: {
        doorId: 'mockedDoorId0',
        name: 'mockedDoorNameUpdated',
        locationId: 'mockedLocationId',
        officeMode: { scheduleType: 'weekSchedule', weekSchedule: [] }
      }
    },
    result: () => ({
      data: {
        updateDoor: mockedUpdateDoorWithOfficeModeDataForMutation.updateDoor
      }
    }),
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: DELETE_DOOR_BY_ID,
      variables: { doorId: 'mockedDoorId0' }
    },
    result: { data: mockedDeleteDoorByIdDataForMutation },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: ASSIGN_ACCESS_GRANTS_TO_DOORS,
      variables: { doorIds: ['mockedDoorId0'], accessGrantIds: ['mockedAccessGrantId'] }
    },
    result: { data: mockedAssignAccessGrantsToDoorsDataForMutation },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: UNASSIGN_ACCESS_GRANTS_FROM_DOORS,
      variables: { doorIds: ['mockedDoorId0'], accessGrantIds: ['mockedAccessGrantId'] }
    },
    result: { data: mockedUnassignAccessGrantsToDoorsDataForMutation },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: UNSET_INSTALLER_BY_ID,
      variables: { visitorId: 'mockedVisitorIdInstaller1' }
    },
    result: { data: mockedUnsetInstallerDataDataForMutation },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: DELETE_VISITOR_BY_ID,
      variables: { visitorId: 'mockedVisitorIdExternalUser1' }
    },
    result: { data: mockedDeleteVisitorByIdDataForMutation },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: SET_VISITOR_BY_ID_WITH_ROLE,
      variables: {
        visitorId: 'mockedExternalUserId',
        name: 'mockedExternalUserName',
        visitorGroupExternalRefs: ['mockedVisitorGroupExternalRefs']
      }
    },
    result: { data: mockedSetVisitorDataForMutation },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: SET_VISITOR_BY_ID_WITH_ROLE,
      variables: {
        visitorId: 'mockedVisitorIdExternalUser1',
        name: 'mockedVisitorNameExternalUser1AfterUpdate',
        visitorGroupExternalRefs: ['mockedVisitorGroupExternalRefs']
      }
    },
    result: { data: mockedSetVisitorDataForMutation },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: SET_VISITOR_BY_ID_WITH_ROLE,
      variables: {
        visitorId: 'mockedVisitorIdExternalUser6',
        name: 'mockedVisitorEmailExternalUser6Edited',
        visitorGroupMembership: [
          {
            role: 'EXTERNAL_GROUP_USER',
            visitorGroupExternalRef: 'mockedVisitorGroupExternalRefs2'
          }
        ]
      }
    },
    result: { data: mockedSetVisitorWithRoleDataForMutation },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: SET_VISITOR_BY_ID,
      variables: {
        visitorId: 'mockedVisitorIdInstaller1',
        name: 'mockedVisitorNameInstaller1Updated',
        visitorGroupExternalRefs: ['mockedVisitorGroupExternalRefsInstallers']
      }
    },
    result: { data: mockedUpdateInstallerDataForMutation },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: SET_INSTALLER,
      variables: {
        email: 'mockedInstallerEmailNew',
        name: 'mockedInstallerNameNew'
      }
    },
    result: { data: mockedSetInstallerDataForMutation },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: UPDATE_ACCESS_GRANT,
      variables: {
        accessGrantId: 'mockedAccessGrantWithDays',
        input: {
          scheduleType: 'weekSchedule',
          weekSchedule: [
            {
              dayName: 'monday',
              from: '08:00:00',
              to: '21:00:00'
            }
          ]
        }
      }
    },
    result: { data: mockedUpdateAccessGrantForMutation1 },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: UPDATE_ACCESS_GRANT,
      variables: {
        accessGrantId: 'mockedAccessGrantWithDays5',
        input: {
          scheduleType: 'weekSchedule',
          weekSchedule: [
            {
              dayName: 'sunday',
              from: '08:00:00',
              to: '21:00:00'
            },
            {
              dayName: 'saturday',
              from: '08:00:00',
              to: '21:00:00'
            }
          ]
        }
      }
    },
    result: { data: mockedUpdateAccessGrantForMutation2 },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: ADD_VISITOR_GROUP_WITH_RETAIL,
      variables: { name: 'co-contractors-new', maxNumberOfMembers: 2, type: VisitorGroupType.CoContractors }
    },
    result: { data: mockedAddVisitorGroupDataForMutation },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: ADD_VISITOR_GROUP_V2,
      variables: { name: 'co-contractors-new', maxNumberOfMembers: 2, type: VisitorGroupType.CoContractors }
    },
    result: { data: mockedAddVisitorGroupDataForMutation },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: UPDATE_VISITOR_GROUP_WITH_RETAIL,
      variables: {
        name: 'co-contractors1',
        visitorGroupId: 'mockedVisitorGroupIdExternalUsers1',
        maxNumberOfMembers: 3
      }
    },
    result: { data: mockedUpdateVisitorGroupDataForMutation },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: UPDATE_VISITOR_GROUP_V2,
      variables: {
        name: 'co-contractors1',
        visitorGroupId: 'mockedVisitorGroupIdExternalUsers1',
        maxNumberOfMembers: 3
      }
    },
    result: { data: mockedUpdateVisitorGroupDataForMutation },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: UPDATE_VISITOR_GROUP_DETAILS_V2,
      variables: {
        input: {
          visitorGroupId: 'mockedVisitorGroupIdExternalUsers1',
          name: 'co-contractors1',
          maxNumberOfMembers: 3,
          isQrCodeVisitInviter: false,
          officeMode: {
            accessGrantId: 'mockedAccessGrantId1',
            isOfficeModeEnabled: false
          }
        }
      }
    },
    result: { data: mockedUpdateVisitorGroupDetailsDataForMutation },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: UPDATE_VISITOR_GROUP_DETAILS_V2,
      variables: {
        input: {
          visitorGroupId: 'mockedVisitorGroupIdExternalUsers1',
          name: 'co-contractors1',
          maxNumberOfMembers: null,
          isQrCodeVisitInviter: false,
          officeMode: {
            accessGrantId: 'mockedAccessGrantId1',
            isOfficeModeEnabled: false
          }
        }
      }
    },
    result: { data: mockedUpdateVisitorGroupDetailsClearedMaxNumberOfMembersDataForMutation },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: ADD_VISITOR_WITH_ROLE,
      variables: {
        email: 'mockedExternalUserEmail',
        name: 'mockedExternalUserName',
        visitorGroupMembership: [
          {
            role: Role.ExternalGroupUser,
            visitorGroupId: 'mockedVisitorGroupIdExternalUsers4'
          }
        ]
      }
    },
    result: { data: mockedAddVisitorWithRoleDataForMutation1 },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: ADD_VISITOR_WITH_ROLE,
      variables: {
        name: 'mockedVisitorEmailExternalUser6Edited',
        email: 'mockedVisitorEmailExternalUser6Edited',
        visitorGroupMembership: [
          {
            role: 'EXTERNAL_GROUP_USER',
            visitorGroupExternalRef: 'mockedVisitorGroupExternalRefs2'
          }
        ]
      }
    },
    result: { data: mockedAddVisitorWithRoleDataForMutation2 },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: DELETE_VISITOR_GROUP_BY_ID,
      variables: {
        visitorGroupId: 'mockedVisitorGroupId1',
        withVisitors: true
      }
    },
    result: { data: mockedDeleteVisitorGroupDataForMutation },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: SET_IS_ADMIN_FOR_GROUP,
      variables: {
        visitorGroupId: 'mockedVisitorGroupId1',
        isAdmin: true
      }
    },
    result: { data: mockedSetIsAdminForGroupDataForMutation },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: UPDATE_ACCESS_GRANT_WITH_IS_OFFICE_MODE_ENABLED,
      variables: {
        accessGrantId: 'mockedAccessGrantId1',
        isOfficeModeEnabled: false
      }
    },
    result: { data: mockedUpdateAccessGrantWithIsOfficeModeForMutation1 },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: DELETE_DOOR_BY_ID,
      variables: { doorId: 'mockedDoorId1' }
    },
    result: { data: mockedDeleteDoorByIdDataForMutation1 },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: ADD_LOCATION,
      variables: { location: { doorIds: [], name: 'mockedLocationName' } as LocationInput }
    },
    result: { data: mockedAddLocationWithDoorsDataForMutation },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: UPDATE_LOCATION,
      variables: {
        id: 'mockedLocationId0',
        location: { doorIds: [], name: 'mockedUpdatedLocationName' } as LocationInput
      }
    },
    result: { data: mockedUpdateLocationWithDoorsDataForMutation },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: DELETE_LOCATION,
      variables: { id: 'mockedAddedLocationId' }
    },
    result: { data: mockedDeleteLocationDataForMutation },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: UPDATE_DOOR_WITH_LOCATIONS,
      variables: {
        doorId: 'mockedDoorId0',
        locationIds: undefined,
        name: 'mockedDoorNameUpdated',
        officeMode: { scheduleType: 'weekSchedule', weekSchedule: [] }
      } as MutationUpdateDoorArgs
    },
    result: { data: mockedUpdateDoorWithLocationsDataForMutation },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: ASSIGN_TO_ACCESS_GRANTS,
      variables: {
        accessGrantIds: ['mockedAccessGrantId0'],
        doorIds: [],
        locationIds: ['mockedLocationId']
      }
    },
    result: { data: mockedAssignToAccessGrantsDataForMutation },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: ASSIGN_TO_ACCESS_GRANTS,
      variables: {
        accessGrantIds: ['mockedAccessGrantId0'],
        doorIds: ['mockedDoorId0'],
        locationIds: []
      }
    },
    result: { data: mockedAssignToAccessGrantsDataForMutation1 },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: ASSIGN_TO_ACCESS_GRANTS,
      variables: {
        accessGrantIds: ['mockedAccessGrantId0', 'mockedAccessGrantId1', 'mockedAccessGrantId2'],
        doorIds: ['mockedDoorId0'],
        locationIds: []
      }
    },
    result: { data: mockedAssignToAccessGrantsDataForMutation2 },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: UNASSIGN_TO_ACCESS_GRANTS,
      variables: {
        accessGrantIds: ['mockedAccessGrantId0'],
        doorIds: [],
        locationIds: ['mockedLocationId']
      }
    },
    result: { data: mockedUnassignToAccessGrantsDataForMutation },
    maxUsageCount: Number.POSITIVE_INFINITY
  },

  {
    request: {
      query: UNASSIGN_TO_ACCESS_GRANTS,
      variables: {
        accessGrantIds: ['mockedAccessGrantId0'],
        doorIds: ['mockedDoorId0'],
        locationIds: []
      }
    },
    result: { data: mockedUnassignToAccessGrantsDataForMutation1 },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: UNASSIGN_TO_ACCESS_GRANTS,
      variables: {
        accessGrantIds: ['mockedAccessGrantId0'],
        doorIds: [],
        locationIds: ['mockedLocationId']
      }
    },
    result: { data: mockedUnassignToAccessGrantsDataForMutation },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: UNASSIGN_TO_ACCESS_GRANTS,
      variables: {
        accessGrantIds: ['mockedAccessGrantId0', 'mockedAccessGrantId1', 'mockedAccessGrantId2'],
        doorIds: ['mockedDoorId0'],
        locationIds: []
      }
    },
    result: { data: mockedUnassignToAccessGrantsDataForMutation2 },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: ACCEPT_LEGAL_DOCUMENTS,
      variables: {
        dpa: {
          documentType: LegalDocumentType.Dpa,
          versionHash: 'DPAVersionHash',
          acceptedVersion: 'mockedCurrentVersion'
        },
        sla: {
          documentType: LegalDocumentType.Sla,
          versionHash: 'SLAVersionHash',
          acceptedVersion: 'mockedCurrentVersion'
        }
      }
    },
    result: { data: mockedAcceptLegalDocumentsDataForMutation1 },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: ACCEPT_LEGAL_DOCUMENTS,
      variables: {
        dpa: 'DPAid',
        sla: 'SLAid'
      }
    },
    result: () => ({ data: {} }),
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: ADD_REST_API_KEY,
      variables: {
        description: 'mockedAddedRestAPIKeyName'
      }
    },
    result: { data: mockedAddRestAPIKeyDataForMutation },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: UPDATE_REST_API_KEY,
      variables: {
        id: 'mockedRestApiKeyId',
        description: 'updatedName'
      }
    },
    result: { data: mockedUpdateRestAPIKeyDataForMutation },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: DELETE_REST_API_KEY,
      variables: {
        id: 'mock-key-1'
      }
    },
    result: { data: mockedDeleteRestAPIKeyDataForMutation },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: CHOOSE_PROVIDER,
      variables: {
        provider: Provider.Cognito
      }
    },
    result: { data: mockedChooseCognitoPrividerDataForQuery },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: CHOOSE_PROVIDER,
      variables: {
        provider: Provider.Entra
      }
    },
    result: { data: mockedChooseEntraPrividerDataForQuery },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: GO_BACK_ONE_ONBOARDING_STEP
    },
    result: { data: mockedGoBackOneOnboardingStepDataForQuery },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: VERIFY_ACCOUNT,
      variables: {
        email: 'email@email.com',
        code: '000000'
      }
    },
    result: { data: mockedVerifyCognitoUserDataForQuery },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: GO_BACK_ONE_ONBOARDING_STEP
    },
    result: { data: mockedGoBackOneOnboardingStepDataForQuery },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: RESEND_VERIFICATION_CODE,
      variables: {
        email: 'mock email'
      }
    },
    result: { data: null },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: SET_MFA_PREFERENCE,
      variables: {
        emailMfaEnabled: false
      }
    },
    result: { data: mockedSetMfaPreferenceDataForQuery },
    maxUsageCount: Number.POSITIVE_INFINITY
  }
];
